// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__lnXXd","rootCenter":"LoadMoreObserver_rootCenter__1ZZsu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1ov5J"};